import { defaultTo, merge } from 'lodash';
import { Howler as Sounds } from 'howler';
import { registerEventListener, triggerEvent } from './Utility';

export class Audio {
  constructor(options) {
    this.setOptions(options);
    this.setListeners();
    this.isSoundOff = false;

    if ('audioSession' in navigator) {
      navigator.audioSession.type = 'playback';
    }
  }

  setOptions(options = {}) {
    this.isSoundOff = defaultTo(options.mute, false);

    this.options = merge({
      mute: this.isSoundOff,
      loop: false,
      rate: 1,
      volume: 1,
    }, options);
  }

  setListeners() {
    const source = 'AudioUtility';

    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        if (this.isSoundOff === false) {
          Sounds.mute(false);
        }
      } else {
        Sounds.mute(true);
      }
    });

    registerEventListener('SetSound', (event) => {
      this.mute(event.detail.isSoundOff);
    }, source);

    if (window.integration) {
      // Sent from casino-client-slots application
      registerEventListener('Integration.ToggleMute', (event) => {
        this.mute(event.detail.value, true);
      });
    }
  }

  mute(isSoundOff, sentFromIntegration) {
    if (this.isSoundOff !== isSoundOff) {
      this.isSoundOff = isSoundOff;
      this.options.mute = isSoundOff;

      Sounds.mute(isSoundOff);

      triggerEvent('MuteChanged', { isSoundOff });

      if (window.integration && !sentFromIntegration) {
        window.integration.toggleMute({ newValue: isSoundOff });
      }
    }
  }

  toggleMute() {
    this.mute(!this.isSoundOff);
  }

  play(asset, options = {}, instanceId = undefined) {
    if (this.options.mute || this.isSoundOff) {
      return undefined;
    }

    if (asset?.resource) {
      try {
        const rate = defaultTo(options.rate, this.options.rate);
        const loop = defaultTo(options.loop, this.options.loop);
        const volume = defaultTo(options.volume, this.options.volume);

        asset.resource.rate(rate);
        asset.resource.volume(volume);

        const playInstanceId = asset.resource.play(instanceId);
        asset.resource.loop(loop);

        return playInstanceId;
      } catch (error) {
        console.warn('[GamesWebgl]SoundPlayError', error.message);
      }
    }

    return undefined;
  }

  stop(asset, instanceId, options = {}) {
    if (asset?.resource) {
      try {
        const rate = defaultTo(options.rate, this.options.rate);

        asset.resource.rate(rate);

        if (instanceId) {
          asset.resource.stop(instanceId);
        } else {
          asset.resource.stop();
        }
      } catch (error) {
        console.warn('[GamesWebgl]SoundStopError', error.message);
      }
    }
  }

  pause(asset, instanceId) {
    if (asset?.resource) {
      try {
        asset.resource.pause(instanceId);
      } catch (error) {
        console.warn('[GamesWebgl]SoundPauseError', error.message);
      }
    }
  }
}
